import { BasePathProvider, useBasePath } from "components/Providers";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { get as getAsset, getAssetLogs } from "store/asset/asset-assign";
import AddAssetForm from "./AddAssetForm";
import AssetFormSekeleton from "./FormSekeleton";
import AssignAssetForm from "./AssignAssetForm";
import AssetLogList from "./AssetLogs";
import TransferAsset from "./TransferAsset";

export default function AssignAssetFormIndex({ assetType, vendors, assetCondition }) {
    const dispatch = useDispatch();
    const [asset, setAsset] = useState(null);
    const basePath = useBasePath();
    const { id } = useParams();
    const location = useLocation();
    const action = location.state?.action;
    const [assetLogs, setAssetLogs] = useState(null);

    useEffect(() => {
        if (id && id !== 'new' && action !== 'assetLogs') {
            dispatch(getAsset({ id })).then(res => {
                setAsset(res.payload);
            })
        }
        else {
            setAsset(null);
        }
    }, [dispatch, id, action])

    useEffect(() => {
        if (id && action === 'assetLogs') {
            dispatch(getAssetLogs({ id })).then(res => {
                setAssetLogs(res.payload || []);
            })
        }
        else {
            setAssetLogs(null);
        }
    }, [dispatch, id, action])

    if ((action === 'edit' && asset) || id === 'new') {
        return (
            <BasePathProvider value={`${basePath}`}>
                <AddAssetForm asset={asset} assetType={assetType} vendors={vendors} assetCondition={assetCondition} />
            </BasePathProvider>
        )
    }

    if (action === 'assetLogs' && assetLogs) {
        return (
            <BasePathProvider value={`${basePath}`}>
                <AssetLogList asset={asset} assetLogs={assetLogs} />
            </BasePathProvider>
        )
    }

    if (action === 'transfer' && asset) {
        return (
            <BasePathProvider value={`${basePath}`}>
                <TransferAsset asset={asset} />
            </BasePathProvider>
        )
    }

    if ((action !== 'edit' && action !== 'assetLogs') && asset) {
        return (
            <BasePathProvider value={`${basePath}`}>
                <AssignAssetForm asset={asset} assetType={assetType} assetCondition={assetCondition} action={action} />
            </BasePathProvider>
        )
    }

    if ((!asset && action !== 'assetLogs') || (!assetLogs && action === 'assetLogs')){
        return <AssetFormSekeleton />
    }
}